import { cva } from 'class-variance-authority';

export const tooltipVariants = cva(
  'flex flex-col gap-xs max-w-[320px] bg-solid-primary shadow-lg dark:border dark:bg-[var(--palette-common-white)] dark:border-[var(--palette-gray-100)]',
  {
    variants: {
      description: {
        false: 'p-sm',
        true: 'p-lg',
      },
    },
  },
);

export const tooltipArrowClassname =
  'w-3 h-3 -z-10 before:!border-[var(--bg-solid-primary)] dark:before:!border-[var(--palette-common-white)]';
